import { Button, Icon, IconProps } from "@pepperstone/pepper-ui-kit";

export type IconButtonProps = IconProps & { onClick?: () => void };

export const IconButton = ({ onClick, ...iconProps }: IconButtonProps) => (
  <Button
    type="button"
    className="flex !h-8 w-8 cursor-pointer items-center justify-center rounded-lg hover:!bg-cta-secondary-hover--dark lg:!h-10 lg:w-10"
    variant="ps-btn-transparent"
    onClick={onClick}
  >
    <Icon {...iconProps} />
  </Button>
);
